const IBAN_COUNTRY_LENGTHS: Record<string, number> = {
    AD: 24,
    AE: 23,
    AT: 20,
    AZ: 28,
    BA: 20,
    BE: 16,
    BG: 22,
    BH: 22,
    BR: 29,
    BY: 28,
    CH: 21,
    CR: 22,
    CY: 28,
    CZ: 24,
    DE: 22,
    DK: 18,
    DO: 28,
    EE: 20,
    EG: 29,
    ES: 24,
    FI: 18,
    FO: 18,
    FR: 27,
    GB: 22,
    GE: 22,
    GI: 23,
    GL: 18,
    GR: 27,
    GT: 28,
    HR: 21,
    HU: 28,
    IE: 22,
    IL: 23,
    IQ: 23,
    IS: 26,
    IT: 27,
    JO: 30,
    KW: 30,
    KZ: 20,
    LB: 28,
    LC: 32,
    LI: 21,
    LT: 20,
    LU: 20,
    LV: 21,
    LY: 25,
    MC: 27,
    MD: 24,
    ME: 22,
    MK: 19,
    MR: 27,
    MT: 31,
    MU: 30,
    NL: 18,
    NO: 15,
    PK: 24,
    PL: 28,
    PS: 29,
    PT: 25,
    QA: 29,
    RO: 24,
    RS: 22,
    SA: 24,
    SC: 31,
    SE: 24,
    SI: 19,
    SK: 24,
    SM: 27,
    ST: 25,
    SV: 28,
    TL: 23,
    TN: 24,
    TR: 26,
    UA: 29,
    VA: 22,
    VG: 24,
    XK: 20,
}

function normalize(value: string): string {
    return (value ?? '').replace(/\s+/g, '').toUpperCase()
}

function mod97(numericString: string): number {
    let remainder = 0
    for (let i = 0; i < numericString.length; i++) {
        remainder = (remainder * 10 + parseInt(numericString[i], 10)) % 97
    }
    return remainder
}

export function useIbanValidation() {
    function isValidIban(rawValue: string): boolean {
        const value = normalize(rawValue)

        if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(value)) {
            return false
        }

        const countryCode = value.slice(0, 2)
        const expectedLength = IBAN_COUNTRY_LENGTHS[countryCode]
        if (expectedLength && value.length !== expectedLength) {
            return false
        }

        const rearranged = value.slice(4) + value.slice(0, 4)
        const numeric = rearranged
            .split('')
            .map((char) => {
                if (char >= '0' && char <= '9') {
                    return char
                }
                return (char.charCodeAt(0) - 55).toString()
            })
            .join('')

        return mod97(numeric) === 1
    }

    function isValidBic(rawValue: string): boolean {
        if (!rawValue) {
            return true
        }
        const value = normalize(rawValue)
        return /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value)
    }

    return {
        isValidIban,
        isValidBic,
    }
}
